import { toast as reactToast } from 'react-toastify';

let currentToast = null;
let isToastActive = false;

const toastConfig = {
  position: 'top-right',
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
  className: 'custom-toast',
  bodyClassName: 'custom-toast-body',
  containerId: 'main-toast-container'
};

const showToast = (type, message, options = {}) => {
  const toastKey = `${type}:${message}`;
  
  if (isToastActive) return null;
  if (currentToast && currentToast.key === toastKey) return null;
  if (currentToast?.id) reactToast.dismiss(currentToast.id);
  
  isToastActive = true;
  const toastId = toastKey.replace(/[^a-zA-Z0-9]/g, '-').substring(0, 100);
  
  const id = reactToast[type](message, {
    ...toastConfig,
    ...options,
    toastId,
    onClose: () => {
      isToastActive = false;
      currentToast = null;
    }
  });
  
  currentToast = { id, key: toastKey, message, type };
  return id;
};

export const toast = {
  success: (message, options = {}) => showToast('success', message, { ...options, className: 'custom-toast custom-toast-success', icon: '✅' }),
  error: (message, options = {}) => showToast('error', message, { ...options, className: 'custom-toast custom-toast-error', icon: '❌' }),
  warning: (message, options = {}) => showToast('warning', message, { ...options, className: 'custom-toast custom-toast-warning', icon: '⚠️' }),
  info: (message, options = {}) => showToast('info', message, { ...options, className: 'custom-toast custom-toast-info', icon: 'ℹ️' }),
  
  dismiss: () => {
    reactToast.dismiss();
    isToastActive = false;
    currentToast = null;
  },

  friendRequest: {
    sent: (username) => toast.success(`Friend request sent to ${username}! 👋`),
    accepted: (username) => toast.success(`You're now friends with ${username}! 🎉`),
    rejected: (username) => toast.info(`Friend request from ${username} declined`),
    removed: (username) => toast.warning(`${username} removed from friends`)
  },

  challenge: {
    created: (title) => toast.success(`Challenge "${title}" created successfully! 🏆`),
    joined: (title) => toast.success(`Joined challenge "${title}"! 🎮`),
    left: (title) => toast.info(`Left challenge "${title}"`),
    deleted: (title) => toast.warning(`Challenge "${title}" deleted`),
    invited: (username) => toast.success(`Invitation sent to ${username}! 📧`)
  },

  problem: {
    solved: (title) => toast.success(`Problem "${title}" solved! 🎯`, { autoClose: 5000 }),
    attempted: (title) => toast.info(`Attempting "${title}"...`),
    saved: () => toast.info('Code saved automatically 💾', { autoClose: 2000 })
  },

  submission: {
    running: () => toast.info('Running your code... ⚡', { autoClose: 2000 }),
    success: (passed, total) => toast.success(`${passed}/${total} test cases passed! ✨`),
    failed: (passed, total) => toast.error(`${passed}/${total} test cases passed. Keep trying! 💪`),
    error: (error) => toast.error(`Execution error: ${error}`)
  },

  auth: {
    login: (username) => toast.success(`Welcome back, ${username}! 👋`),
    logout: () => toast.info('Logged out successfully. See you soon! 👋'),
    register: (username) => toast.success(`Account created! Welcome, ${username}! 🎉`),
    error: (message) => toast.error(message)
  },

  copy: {
    success: (item = 'Link') => toast.success(`${item} copied to clipboard! 📋`, { autoClose: 2000 })
  }
};

export default toast;
